/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineHolidaysCheck200,
  GetApiV1ClassroomdisciplineHolidaysCheck400,
  GetApiV1ClassroomdisciplineHolidaysCheck401,
  GetApiV1ClassroomdisciplineHolidaysCheck500,
  GetApiV1ClassroomdisciplineHolidaysCheckQueryParams,
  GetApiV1ClassroomdisciplineHolidaysCheckQueryResponse,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineHolidaysCheck.ts";
import { holidayConflictViewModelSchema } from "../holidayConflictViewModelSchema.ts";

export const getApiV1ClassroomdisciplineHolidaysCheckQueryParamsSchema = z
  .object({
    Dates: z.optional(z.array(z.string().datetime())),
    ClassStudentIds: z.optional(z.array(z.coerce.number().int())),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineHolidaysCheckQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineHolidaysCheck200Schema = z.array(
  z.lazy(() => holidayConflictViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineHolidaysCheck200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ClassroomdisciplineHolidaysCheck400Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineHolidaysCheck400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineHolidaysCheck401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineHolidaysCheck401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineHolidaysCheck500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineHolidaysCheck500>;

export const getApiV1ClassroomdisciplineHolidaysCheckQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineHolidaysCheck200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineHolidaysCheckQueryResponse>;
